module.exports = __webpack_public_path__ + "static/media/Fail.cda5ba66.svg";